import React, { FC } from 'react';

import styles from './index.module.scss';
import { ClassName, cn } from '../../utils';


export const Divider: FC<ClassName & any> = ({ className, ...props }) => (
    <hr className={cn(styles.divider, className)} {...props} />
);
